import { render, staticRenderFns } from "./nutritionAdvices.vue?vue&type=template&id=1cd9f432&"
import script from "./nutritionAdvices.vue?vue&type=script&lang=js&"
export * from "./nutritionAdvices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports